// removed by extract-text-webpack-plugin
module.exports = {"treeWrapper":"purpose-tree__treeWrapper-_-5QV content__treeWrapper-12zvR"};


//////////////////
// WEBPACK FOOTER
// ./components/common/custom-order/additional-parameters/content/purpose-tree/purpose-tree.css
// module id = 805
// module chunks = 0